<div class="page-layout simple fullwidth">
    <div class="header accent p-24" fxLayout="row" fxLayoutAlign="start center">
        <h2>{{ "DASHBOARD.DASHBOARD" | translate | uppercase }}</h2>
    </div>

    <div class="content">
        <div class="mat-card mat-elevation-z2 p-24" fxLayout="column">
            <div
                fxLayout="row wrap"
                fxLayoutGap="16px grid"
                fxLayoutAlign="center start"
            >
                <ng-container *ngFor="let tarjeta of tarjetas">
                    <app-tarjeta
                        *ngIf="tarjeta.cantidad !== null"
                        [tarjeta]="tarjeta"
                    ></app-tarjeta>
                </ng-container>
            </div>
        </div>
    </div>
</div>
